module.exports = __webpack_public_path__ + "img/folder.313c7ab8.png";